import { Injectable } from '@angular/core';
import { AppWalkMeParametersDto, ExternalScriptDto, ExternalScriptType } from '../services/api.services';
import { logger } from '../pbir/utils/logger';

const LOGGER = logger('ExternalContentService');

@Injectable({ providedIn: 'root' })
export class ExternalContentService {
  public addWalkMeVariables(params: AppWalkMeParametersDto) {
    this.addWalkMeVariable('company', params.company);
    this.addWalkMeVariable('username', params.username);
    this.addWalkMeVariable('version', params.version);
  }

  private addWalkMeVariable(id: string, text: string) {
    let span = document.createElement('span');

    span.id = id;
    span.style.display = 'none';
    span.innerText = text;

    document.body.append(span);
  }

  public appendExternalScripts(externalScripts: ExternalScriptDto[]) {
    for (let s of externalScripts) {
      let script = document.createElement('script');

      script.type = 'text/javascript';

      if (s.type === ExternalScriptType.ExternalScript) {
        script.async = true;
        script.src = s.source;
      }
      else if (s.type === ExternalScriptType.InlineScript) {
        script.innerHTML = s.source;
      }
      else {
        LOGGER.error(`Unknown ExternalScript type '${s.type}'`);
        continue;
      }

      document.head.append(script);
    }
  }
}
